import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";

export default ({ startSale, finalizeSale }) => {
  const ratioSale = startSale > 0 ? ~~((100 * finalizeSale) / startSale) : 0;
  return (
    <p style={{ lineHeight: 1.8, marginTop: 0.3 }}>
      <Tooltip
        title="Nombre d'utilisation de la borne par un client. Que la vente soit finalisée ou non."
        placement="top-start"
      >
        <InfoIcon />
      </Tooltip>
      <label>Nombre de ventes commencées: </label>
      {startSale}
      <br />
      <Tooltip
        title="Nombre d'utilisation de la borne ayant aboutie à une ventes finalisée."
        placement="top-start"
      >
        <InfoIcon />
      </Tooltip>
      <label>Nombre de ventes terminées :</label>
      {finalizeSale}
      <br />
      <Tooltip
        title="Ratio entre les deux valeurs précédentes: ventes terminées/ ventes commencées."
        placement="top-start"
      >
        <InfoIcon />
      </Tooltip>
      <label>Ratio ventes terminées/commencées :</label>
      {ratioSale}%
    </p>
  );
};



// WEBPACK FOOTER //
// ./src/components/activityDetailField.js